export default ($axios) => ({
  fetch(query) {
    return $axios.get('/rcs/reports', { params: query }).then((response) => response.data);
  },
  download(id) {
    return $axios.get(`/rcs/reports/${id}`, { responseType: 'arraybuffer' });
  },
});
